import React from 'react';
import UrlShortener from './UrlShortener';

function App() {
  return (
    <div>
      <UrlShortener />
    </div>
  );
}

export default App;
